// Tiny shared hover tooltip — a single body-level element shown instantly on
// hover (no native <title> delay). Used by the macro & histo annotation shapes.

let el = null;

const ensure = () => {
  if (el) return el;
  el = document.createElement("div");
  el.setAttribute("data-anno-tooltip", "");
  el.style.cssText = [
    "position:fixed",
    "z-index:10000",
    "pointer-events:none",
    "background:rgba(0,0,0,0.82)",
    "color:#fff",
    "font-size:12px",
    "line-height:1.35",
    "padding:4px 8px",
    "border-radius:4px",
    "max-width:280px",
    "white-space:pre-wrap",
    "box-shadow:0 2px 8px rgba(0,0,0,0.35)",
    "display:none",
  ].join(";");
  document.body.appendChild(el);
  return el;
};

const place = (t, x, y) => {
  // Offset from the cursor, nudged back in-bounds near the right/bottom edges.
  const pad = 14;
  const w = t.offsetWidth || 200;
  const h = t.offsetHeight || 28;
  let left = x + pad;
  let top = y + pad;
  if (left + w > window.innerWidth) left = x - w - pad;
  if (top + h > window.innerHeight) top = y - h - pad;
  t.style.left = `${Math.max(4, left)}px`;
  t.style.top = `${Math.max(4, top)}px`;
};

export const showTip = (text, x, y) => {
  if (!text) return;
  const t = ensure();
  t.textContent = text;
  t.style.display = "block";
  place(t, x, y);
};

export const moveTip = (x, y) => {
  if (el && el.style.display === "block") place(el, x, y);
};

export const hideTip = () => {
  if (el) el.style.display = "none";
};
